import styled from 'styled-components';

export const TypeCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 20px;
  margin-bottom: 35px;
`;

export const TypeCard = styled.div<{ $selected?: boolean; $disabled?: boolean }>`
  background: #fff;
  border: 1px solid ${({ $selected }) => ($selected ? '#0b99e6' : '#dddfe3')};
  box-sizing: border-box;
  border-radius: 4px;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  height: 160px;
  padding: 22px 26px;
  position: relative;
  text-align: center;
  min-width: 160px;
  width: 200px;
  flex: 1 1 200px;

  &:active,
  &:focus,
  &:hover {
    background: ${({ $disabled }) => ($disabled ? '#fff' : 'rgba(208, 211, 214, 0.1)')};
  }

  ${({ $selected }) =>
    $selected &&
    `
    background: rgba(208, 211, 214, 0.1);
    border-color: #0b99e6;
  `}

  ${({ $disabled }) =>
    $disabled &&
    `
    pointer-events: none;
    opacity: 0.6;
  `}
`;

export const TypeTitle = styled.div`
  color: #6d747b;
  font-weight: bold;
  font-size: 13px;
  line-height: 13px;
  margin: 11px 0 10px;
  text-align: center;
`;

export const TypeDescription = styled.div`
  color: #717478;
  font-size: 13px;
  line-height: 17px;
  text-align: center;
`;

export const CheckmarkContainer = styled.div<{ $disabled?: boolean }>`
  align-items: center;
  background: ${({ $disabled }) => ($disabled ? '#BCCAD2' : '#4ca667')};
  border-radius: 50%;
  color: #fff;
  display: flex;
  height: 20px;
  justify-content: center;
  position: absolute;
  right: 12px;
  top: 12px;
  width: 20px;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
`;
